<template>
  <div class="app-container">
    <el-form ref="queryForm" :inline="true" label-width="80px">
      <!-- <el-form-item label="选择店铺">
        <el-select v-model="selectedShop" placeholder="请选择店铺" style="width: 240px;" filterable
          @change="handleShopChange">
          <el-option v-for="item in shopList" :key="item.id" :label="item.shop_name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="商品名称">
        <el-input v-model="queryParams.goods_name" placeholder="请输入商品名称" clearable size="small" />
      </el-form-item> -->
      <!-- <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini"
          @click="handleQuery">查询</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item> -->
    </el-form>

    <div class="gap"></div>
    <el-table v-loading="loading" :data="tableList">
      <el-table-column label="商品ID" align="center" label-class-name='title' prop="goods_id" width="100" />
      <el-table-column label="商品名称" align="center" label-class-name='title' prop="goods_name" />
       <el-table-column  label="商品图片" align="center" width="200" label-class-name='title' prop="goods_url">
          <template slot-scope="scope">
              <div class="flex">
                 <img class="img" v-for="(item,index) in scope.row.goods_url.split(',')" :src = 'item'></img>
     
              </div>
        </template>

        </el-table-column>
      <el-table-column label="商品类别" align="center" label-class-name='title' :formatter="transType"
        prop="goods_type" />
      <el-table-column label="商品价格" align="center" label-class-name='title' prop="goods_price" />
      <el-table-column label="库存数量" align="center" label-class-name='title' width="180">
        <template slot-scope="scope">
          <el-input-number v-model="scope.row.stock"  size="small" controls-position="right" />
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="120" label-class-name='title'
        class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button class="inspect-button" size="mini" type="primary" icon="el-icon-check"
            @click="handleSave(scope.row)">保存</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-show="total > 0" :total="total" @current-change="getList" @prev-click='getList'
      @next-click="getList" />
  </div>
</template>

<script>
import { shopStockAdd, shopStockList, shopStockUpdate } from '../api/shopStock/index'
import { goodsList } from '../api/goods/index'
import { shopList as getShopList } from '../api/shop/index'
import { typeList } from '../api/type/index'
export default {
  name: 'ShopStock',
  data () {
    return {
      shopList: [],
      typeList: [],
      selectedShop: '',
      selectedShopName: '',
      goodsList: [],
      stockList: [],
      tableList: [],
      queryParams: {},
      loading: false,
      pageIndex: 1,
      pageSize: 10,
      total: 0
    }
  },

  created () {
    let flag = sessionStorage.getItem('login')
    if (!flag) {
      this.$router.push('/')
    }
    this.getShopOptions()
    this.getTypeList()
  },
  methods: {
    //  获取店铺下拉
    getShopOptions () {
      getShopList({ pageIndex: 1, pageSize: 9999 }).then(res => {
        this.shopList = res.data.list || []
        this.selectedShop = this.shopList[0].id || ''
        this.loadData()
      })
    },
    //  获取商品类别
    getTypeList () {
      typeList({}).then(res => {
        this.typeList = res.data.list || []
      })
    },
    //  商品类别转换
    transType (row) {
      let list = this.typeList
      for (let i = 0; i < list.length; i++) {
        if (list[i].type_code === row.goods_type) {
          return list[i].type_name
        }
      }
      return row.goods_type
    },
    //  店铺切换
    handleShopChange () {
      let shop = this.shopList.find(s => s.id === this.selectedShop)
      this.selectedShopName = shop ? shop.shop_name : ''
      this.pageIndex = 1
      this.loadData()
    },
    //  加载商品与库存数据
    loadData () {
      if (!this.selectedShop) {
        this.$message.warning('请先选择店铺')
        return
      }
      this.loading = true
      let params = this.queryParams
      params.pageIndex = this.pageIndex
      params.pageSize = this.pageSize

      //  并行加载商品列表与该店铺的库存记录
      Promise.all([
        goodsList(params),
        shopStockList({ shop_id: this.selectedShop, pageIndex: 1, pageSize: 9999 })
      ]).then(([goodsRes, stockRes]) => {
        this.goodsList = goodsRes.data.list || []
        this.total = goodsRes.data.total || 0
        this.stockList = stockRes.data.list || []
        this.mergeTableData()
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    //  合并商品与库存数据
    mergeTableData () {
      this.tableList = this.goodsList.map(goods => {
        let stockRecord = this.stockList.find(s => s.goods_id === goods.goods_id)
        return {
          goods_id: goods.goods_id,
          goods_name: goods.goods_name,
          goods_type: goods.goods_type,
          goods_price: goods.goods_price,
          stockId: stockRecord ? stockRecord.id : '',
          stock: stockRecord ? stockRecord.stock : 0,
          goods_url: goods.goods_url
        }
      })
    },
    //  保存单行库存
    handleSave (row) {
      if (!this.selectedShop) {
        return this.$message.warning('请先选择店铺')
      }
      let params = {
        shop_id: this.selectedShop,
        shop_name: this.selectedShopName,
        goods_id: row.goods_id,
        stock: row.stock
      }
      if (row.stockId) {
        params.id = row.stockId
        shopStockUpdate(params).then(res => {
          this.$message.success('修改成功')
          this.loadData()
        })
      } else {
        shopStockAdd(params).then(res => {
          this.$message.success('保存成功')
          this.loadData()
        })
      }
    },
    handleQuery () {
      this.pageIndex = 1
      this.loadData()
    },
    resetQuery () {
      this.queryParams = {
        goods_name: ''
      }
      this.pageIndex = 1
      this.handleQuery()
    },
    getList (e) {
      this.pageIndex = e
      this.loadData()
    }
  }
}
</script>
<style>
.app-container {
  margin-top: 40px;
}

.gap {
  margin: 30px 10px;
}

.title {
  color: black;
}
  .img{
    width: 50px;
    height: 50px;
    margin-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/shopStock.vue